import { React, useEffect } from 'react';

// REDUX
import { useSelector, useDispatch } from 'react-redux';
import { getIncomeDisposal } from '../../../store/actions/evidenceList';

import { Loader, formatNumber } from '../../../utils/tools';

import { Row, Col } from 'react-bootstrap';

const IncomeDisposal = ({ branchId }) => {

    const dispatch = useDispatch();

    const currentEvidenceList = useSelector(state => state.evidenceList.current);
    const id = currentEvidenceList._id;
    const loading = useSelector(state => state.evidenceList.loading);

    const year = useSelector(state => state.uiSlice.selectedYear);

    useEffect(() => {
        if(branchId && id)
            dispatch(getIncomeDisposal({id, currentBranchId: branchId, year}))
    }, [id, branchId, year, dispatch, loading]);

    const summary = useSelector(state => state.evidenceList.current.summary);

    return (
        <>
            { !summary  ? (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '35vh',
                    }}
                >
                    <Loader />
                </div>
            )  : <div>
                
                <Row>
                    <Col className="text-center">
                        <div className="evidence-stat-label">Vznik/príjem</div>
                        <div className="evidence-stat-value">{ formatNumber(summary.income ?? 0).replace('.', ',') }</div>
                    </Col>
                    <Col className="text-center">
                        <div className="evidence-stat-label">Nakladanie</div>
                        <div className="evidence-stat-value">{ formatNumber(summary.disposal ?? 0).replace('.', ',') }</div>
                    </Col>
                    <Col className="text-center">
                        <div className="evidence-stat-label">Zostatok</div>
                        <div className={`evidence-stat-value evidence-stat-balance${(summary.balance ?? 0) > 0 ? ' positive' : ' negative'}`}>
                            { formatNumber(summary.balance ?? 0).replace('.', ',') }
                        </div>
                    </Col>
                </Row>
                    
                </div>
            }
        </>
    )
};

export default IncomeDisposal;
